import { TicketIcon } from '@heroicons/react/outline';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { ButtonSubmit } from '../components/form/button/Button';
import { getBaseURL } from '../config/runtime';
import { Product } from '../domain/product/product';

export function ProductRenameDialog({
  product,
  onClose,
  onSuccess: onSuccessProp,
}: {
  product: Product;
  onClose: () => void;
  onSuccess: (name: string) => void;
}) {
  const baseUrl = getBaseURL();
  const [name, setName] = React.useState('');

  const renameMutation = useMutation({
    mutationFn: async (name: string) => {
      const resp = await fetch(
        `${baseUrl}/v1/client/products/${product.id}/name?value=${name}`,
        {
          method: 'PUT',
        }
      );
    },
    onSuccess: (data) => {
      onSuccessProp(name);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  function submitHandler() {
    if (name.trim().length === 0) {
      onClose();
      return;
    }

    renameMutation.mutate(name);
    onClose();
  }

  return (
    <div className="flex flex-col rounded-b-md bg-white px-6 py-3 pb-6">
      <div className="mb-4 flex gap-x-4">
        <img
          src={`${baseUrl}/product/${product.id}/image?width=170`}
          alt={product.name}
          className="h-auto w-[170] rounded-sm"
        />
        <header>
          <h1 className="text-2xl font-bold text-gray-800">{product.name}</h1>
        </header>
      </div>
      <div className="">
        <label className="text-base text-gray-700">
          Please enter a new product name
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          className="box-border w-full px-2 py-1"
          placeholder={product.name}
        />
        <div className="mt-5">
          <ButtonSubmit
            Icon={TicketIcon}
            disabled={renameMutation.isPending}
            onClick={submitHandler}
            text="Save"
          />
        </div>
      </div>
    </div>
  );
}
